/* LabUserSessionMixin.js */

"use strict";
const _ = require("lodash");
const BaseUserSessionAdapter = require("../BaseUserSessionMixin");
const mix = require("../util/mix");

let mixin = (superKlass) =>
    class LabUserSessionAdapter extends mix(superKlass).with(BaseUserSessionAdapter) {
        /**
         * Get the Current Org.
         */
        pmGetCurrentOrg(/*continuation*/) {
            if (this._labUserSession) {
                let activeOrg = this._labUserSession.getActiveOrganization();
                return Promise.resolve(_.get(activeOrg, "name"));
            } else {
                return Promise.resolve();
            }
        }

        /**
         * Get the current user name.
         */
        pmGetCurrentUserName(/*continuation*/) {
            if (this._labUserSession) {
                let user = this._labUserSession.getUser();
                return Promise.resolve(_.get(user, "userName"));
            } else {
                return Promise.resolve();
            }
        }
    };
module.exports = mixin;
